<template>
  <SelectWithSearch
    v-model="input"
    :label="label"
    :change="change"
    :options="search"
    :search="onSearch"
    :filterBy="descriptionFilter"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">
        {{ formatOption(props) }}
      </div>
    </template>
    <template slot="no-options">
      Selecione um CST {{ this.type === 'CST' ? '' : this.type }}
    </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">
        {{ formatOption(props) }}
      </div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapState } from 'vuex';

export default {
  name: 'AutocompleteCST',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    label: {
      type: String,
      required: false,
      default: () => 'CST',
    },
    addDefault: {
      type: String,
      required: false,
      default: () => null,
    },
    id: {
      type: String,
      required: false,
      default: () => 'autocomplete-cst-default',
    },
    type: {
      type: String,
      required: false,
      default: () => 'CST',
      validator(value) {
        return ['CST', 'PIS', 'COFINS'].indexOf(value) !== -1;
      },
    },
    value: {},
  },
  data() {
    return {
      props: {
        CST: 'cstId',
        PIS: 'cstPisId',
        COFINS: 'cstCofinsId',
      },
      collection: [],
      search: [],
      input: undefined,
    };
  },
  async mounted() {
    await this.getCollection();

    const propIdTag = this.props[this.type];

    if (this.service.fiscal[propIdTag]) {
      const propIdValue = this.service.fiscal[propIdTag];
      const currentCst = this.collection.find((cst) => cst.id === propIdValue);

      this.$emit('input', currentCst);
    }
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
  computed: {
    ...mapState('service', ['service']),
  },
  methods: {
    async getCollection() {
      const urls = {
        cst: 'fiscal.get-cst',
        pis: 'fiscal.get-cstpis',
        cofins: 'fiscal.get-cstcofins',
      };
      const { data } = await this.$http.post(urls[this.type] || urls.cst);

      this.collection = data;
      this.search = data;

      if (this.addDefault && !this.value) {
        const defaultCst = this.collection.find(
          (cst) => this.addDefault === cst.codigo,
        );
        this.$emit('input', defaultCst);
      }
    },
    onSearch(value) {
      this.search = this.searchCollection(this.collection, value, [
        'descricao',
        'codigo',
      ]);
    },
    change(value) {
      this.$emit('input', value);
    },
    formatOption(props) {
      return `${props.data.codigo} - ${props.data.descricao}`;
    },
  },
};
</script>
